/* @flow */

import { getLocaleDictionary } from '../../../locales';
import { addListener } from './messaging';

addListener('i18n', locale => getLocaleDictionary(locale));



// WEBPACK FOOTER //
// ./lib/environment/background/i18n.js